import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useBillableUnit} from "../hooks/useBillableUnit.ts";
import {
    BillableUnit,
    BillableUnitStatus
} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useBillableUnit();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                description: '',
                meterId: '',
                // Default to 1:1 — the common case, and it matches the server-side
                // default so the form never implies a factor that isn't really there.
                meteredUnitsPerBillableUnit: 1,
                status: BillableUnitStatus.DRAFT,
            } as BillableUnit}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
